var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLeaf = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.9C11.0667 19.9 10.1877 19.754 9.363 19.462C8.53767 19.1707 7.78333 18.7584 7.1 18.225L5.7 19.6C5.51667 19.7834 5.28333 19.875 5 19.875C4.71667 19.875 4.48333 19.7834 4.3 19.6C4.11667 19.4167 4.025 19.1834 4.025 18.9C4.025 18.6167 4.11667 18.3834 4.3 18.2L5.675 16.825C5.14167 16.1417 4.72933 15.3834 4.438 14.55C4.146 13.7167 4 12.8334 4 11.9C4 9.66669 4.775 7.77502 6.325 6.22502C7.875 4.67502 9.76667 3.90002 12 3.90002H20V11.9C20 14.1334 19.225 16.025 17.675 17.575C16.125 19.125 14.2333 19.9 12 19.9ZM12 17.9C13.6667 17.9 15.0833 17.3167 16.25 16.15C17.4167 14.9834 18 13.5667 18 11.9V5.90002H12C10.3333 5.90002 8.91667 6.48336 7.75 7.65002C6.58333 8.81669 6 10.2334 6 11.9C6 12.55 6.1 13.1707 6.3 13.762C6.5 14.354 6.775 14.8917 7.125 15.375L12.3 10.2C12.4833 10.0167 12.7167 9.92502 13 9.92502C13.2833 9.92502 13.5167 10.0167 13.7 10.2C13.9 10.4 14 10.6374 14 10.912C14 11.1874 13.9 11.425 13.7 11.625L8.525 16.8C9.00833 17.15 9.54567 17.4207 10.137 17.612C10.729 17.804 11.35 17.9 12 17.9Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLeaf);
export default ForwardRef;